export default __webpack_public_path__ + "static/media/houseSearch.334eee2a.svg";